export default {
  isShown: (state) => state.isShown,
  errors: (state) => state.errors,
  errorsMessages: (state) => state.errorsMessages,
  paymentMethodBonuses: (state) => state.paymentMethodBonuses,
};
